import confetti from "canvas-confetti";

// Kurzer iOS-bunter Konfetti-Moment (z. B. bei Freigaben)
export function celebrate() {
  const colors = ["#007AFF", "#34C759", "#FF9500", "#FF2D55", "#AF52DE", "#FFCC00"];
  try {
    confetti({ particleCount: 90, spread: 75, startVelocity: 42, origin: { y: 0.7 }, colors, zIndex: 9999 });
    setTimeout(() => {
      try {
        confetti({ particleCount: 45, spread: 110, startVelocity: 32, origin: { y: 0.6 }, colors, zIndex: 9999 });
      } catch {
        // Animation ist rein dekorativ.
      }
    }, 220);
  } catch {
    // Canvas kann in eingebetteten oder eingeschraenkten Browsern fehlen.
  }
}
